import { useGif } from "@portal/providers/GifProvider";
import { NodeViewProps, NodeViewWrapper } from "@tiptap/react";
import { GifDisplay } from "./gif/GifDisplay";
import { Spinner } from "./Spinner";

interface DynamicImageAttrs {
	id: string;
}

// Can't destructure in the input as it is an imported type
export const KLIPYTagComponent = (props: NodeViewProps) => {
	const { id } = props.node.attrs as DynamicImageAttrs;
	// fetch single gif

	const { data, error } = useGif(id);

	return (
		<NodeViewWrapper>
			{error ? (
				<div className="flex items-center justify-center border border-gray-200 rounded-md select-none">
					There was an error loading this GIF
				</div>
			) : (
				<>
					{data ? (
						<div className="max-w-[350px] object-contain">
							<GifDisplay id={data.id} />
						</div>
					) : (
						<div>
							<Spinner />
						</div>
					)}
				</>
			)}
		</NodeViewWrapper>
	);
};
